export default __webpack_public_path__ + "static/media/big-banner-design.3dfd639c.jpg";